// extracted by mini-css-extract-plugin
export default {"title":"AddHelp_title__6ICDq","boxForm":"AddHelp_boxForm__jPpBv","form":"AddHelp_form__pm74c"};